var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h3',{staticClass:"page-title text-center"},[_vm._v(_vm._s(_vm.title))]),_c('dashboard-list-box',{attrs:{"rows":_vm.rows,"columns":_vm.columns}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }